import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Target, Zap, TrendingDown, Sparkles, Loader2 } from "lucide-react";
import Btn from "../components/Btn";
import api, { apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Drills() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const { user, setUser } = useAuth();
  const nav = useNavigate();

  useEffect(() => { api.get("/drills/analyze").then(({ data }) => setData(data)).catch(() => {}); }, []);

  const start = async () => {
    if (user.energy < 8) {
      toast.error("Energi tidak cukup (butuh 8). Mengarahkan ke halaman pembelian...");
      setTimeout(() => nav("/pricing"), 1200);
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/drills/start");
      setUser({ ...user, energy: user.energy - 8 });
      nav(`/cbt/${data.attempt_id}`, { state: data });
    } catch (e) {
      if (e?.response?.status === 402) {
        toast.error(apiErr(e) + " — mengarahkan ke halaman pembelian...");
        setTimeout(() => nav("/pricing"), 1200);
      } else {
        toast.error(apiErr(e));
      }
      setBusy(false);
    }
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h1 className="font-heading font-black text-2xl sm:text-3xl flex items-center gap-2"><Target className="w-7 h-7 text-su-energy" /> Drill Adaptif</h1>
        <p className="text-su-muted font-medium">AI menyusun 8 soal khusus dari titik lemahmu. Biaya <span className="font-heading font-black text-su-energy">8 ⚡</span></p>
      </div>

      {!data ? (
        <div className="grid place-items-center py-16"><Loader2 className="w-10 h-10 animate-spin text-su-primary" /></div>
      ) : !data.has_history ? (
        <div className="card-chunky p-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-su-track grid place-items-center mx-auto mb-3"><Sparkles className="w-8 h-8 text-su-muted" /></div>
          <h2 className="font-heading font-black text-xl mb-1">Belum ada data kelemahan</h2>
          <p className="text-su-muted font-medium mb-5">Selesaikan minimal satu tryout agar AI bisa menganalisis titik lemahmu.</p>
          <Btn onClick={() => nav("/tryouts")}>Mulai Tryout Dulu</Btn>
        </div>
      ) : (
        <>
          <div className="card-chunky p-6">
            <h2 className="font-heading font-black text-lg mb-4 flex items-center gap-2"><TrendingDown className="w-5 h-5 text-su-danger" /> Titik Lemahmu</h2>
            <div className="space-y-4">
              {data.weak.map((w) => (
                <div key={w.subtopic} data-testid={`weak-${w.subtopic}`}>
                  <div className="flex items-center justify-between font-heading font-extrabold mb-1.5">
                    <span>{w.subtopic}</span><span className="font-mono text-su-danger">{w.accuracy}%</span>
                  </div>
                  <div className="h-3 rounded-full bg-su-track overflow-hidden">
                    <div className="h-full rounded-full bg-su-danger" style={{ width: `${w.accuracy}%` }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="card-chunky p-6 text-center">
            <p className="font-heading font-extrabold text-lg mb-1">Siap perbaiki kelemahanmu?</p>
            <p className="text-su-muted font-medium mb-5">8 soal terkurasi khusus untukmu.</p>
            <Btn data-testid="drill-start" onClick={start} disabled={busy} size="lg" className="w-full max-w-xs mx-auto">
              {busy ? "Menyiapkan..." : <><Zap className="w-5 h-5 fill-current" /> Mulai Drill Adaptif</>}
            </Btn>
          </div>
        </>
      )}
    </div>
  );
}
